interface LabelProps {
  children: React.ReactNode;
  className?: string;
}

export function Label({ children, className = '' }: LabelProps) {
  return (
    <div className={`font-mono text-[10px] tracking-[0.16em] uppercase ${className}`}>
      {children}
    </div>
  );
}
